import React from 'react';
import '../css/contact.css';

const Contact = () => {
  return (
    <section id="contact" className="contact-section">
      <h2>Contact</h2>
      <p>Email: <a href="mailto:praveenkumarp893@gmail.com">praveenkumarp893@gmail.com</a></p>
      <p>Phone: 07721879528</p>
    </section>
  );
};

export default Contact;
